var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import * as React from "react";

function SvgShCloseSolid(props) {
  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17" }, props),
    React.createElement("path", {
      d: "M8.5 17A8.51 8.51 0 010 8.5 8.51 8.51 0 018.5 0 8.509 8.509 0 0117 8.5 8.51 8.51 0 018.5 17zM5.805 4.705a.451.451 0 00-.322.133l-.858.858a.461.461 0 000 .646l2.362 2.362-2.362 2.363a.462.462 0 000 .646l.858.858a.461.461 0 00.324.132.453.453 0 00.322-.132l2.362-2.362 2.362 2.362a.464.464 0 00.325.132.45.45 0 00.321-.132l.858-.858a.46.46 0 000-.646L10 8.7l2.362-2.362a.456.456 0 00.136-.327.448.448 0 00-.136-.319l-.858-.858a.461.461 0 00-.324-.133.452.452 0 00-.322.133L8.496 7.196 6.134 4.834a.461.461 0 00-.328-.128z",
      fill: "rgba(154,154,154,0.8)"
    })
  );
}

export default SvgShCloseSolid;